import React, { useState } from 'react';
import './login.css'
import image from './images/fsb111.png'
import img from './images/bgsupp1.jpg'
import imgg from './images/google.png'
import { Link, useNavigate } from 'react-router-dom';
import GoogleIcon from '@mui/icons-material/Google';
import {auth} from "./firebase";
import { signInWithEmailAndPassword } from 'firebase/auth';
import { createUserWithEmailAndPassword } from 'firebase/auth';
import { useUserAuth } from './UserAuthContext';
import { Alert } from 'react-bootstrap';

function Login() {
  const navigate = useNavigate();
  const[email,setEmail] = useState('');
  const[error, setError] = useState('');
  const[password,setPassword] = useState('');
  const {login, googleSignIn} = useUserAuth();

  const handleSubmit = async(e) => {
    e.preventDefault();
    setError("");
    try{
        await login(email, password);
        navigate("/home")
    }
    catch(error){
            setError(error.message)
    }

}

const handleGoogleSignIn = async(e) => {
  e.preventDefault();
  try{
      await googleSignIn();
      navigate("/home")
  }
  catch(error){
    setError(error.message)
  }
}

  return (
    <div className='login'>
       <img className='imgbg' src = {img} alt = ""/>

      <div className='login-content'>
        <Link to = "/">
      <img className = "login__logo" src = {image} alt = ""></img>
      </Link>
      <div className='login__container'>
        <h1>Sign up or Login With</h1>
        <button className="login__signInGoogleButton" onClick={handleGoogleSignIn}>
  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} className="login__signInButtonText">Google&nbsp;
  <span ><img src = {imgg} className="login__signInButtonIcon"/></span></div>
  
</button>
<p className='login__orSeparator'>
      <span className='login__orText'>Or</span>
    </p><br/>{error && <Alert className='error'>{error}</Alert>}
        <form onSubmit={handleSubmit}>
            <h5>E-mail</h5>
            <input placeholder = "name@host.com" type = "text" value = {email} onChange = {e => setEmail(e.target.value)}/>
            <h5>Password</h5>
            <input placeholder = "Password" type = "password" value = {password} onChange = {e => setPassword(e.target.value)}/><br/>
            <button type = "submit" className={`login__signInButton ${email ? '' : 'low-opacity'}`}>Sign In</button>  
            <a className = "trouble" href = "javascript:void(0)"><p>Don't have an Account?</p></a>
        </form>
        <Link to = "/signup"><button className='login__registerButton' /*onClick={register}*/>Create your FibreShop Account</button></Link>
      </div>
      </div>
        

    </div>
  );
}

// import React from 'react';
// import './Login.css'; // Import your CSS file for styling

// function Login() {
//   return (
//     <div className='login-container'>
//       <video autoPlay loop muted className="video-background">
//         <source src={video} type="video/mp4" />
//         Your browser does not support the video tag.
//       </video>
//       <div className='login-content'>
//         <img src={image} alt="" />
//         {/* Add your login form or content here */}
//       </div>
//     </div>
//   );
// }

export default Login;
